"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CategoryCodeMILX = function CategoryCodeMILX(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 16 16"
  }, props), _react.default.createElement("g", null, _react.default.createElement("title", null, "CategoryCodeMILX"), _react.default.createElement("path", {
    d: "M12.564,10.487a.808.808,0,0,0-.639-.18s.008-3.907.008-3.932a3.95,3.95,0,1,0-7.9,0c0,.04-.013,3.924-.013,3.924a.75.75,0,0,0-.58.188.812.812,0,0,0-.1,1.129l4.683,1.963,4.68-2.024A.8.8,0,0,0,12.564,10.487ZM5.239,7.125a.553.553,0,0,1,.553-.554H7.037a.554.554,0,1,1,0,1.108H5.792A.554.554,0,0,1,5.239,7.125Zm2.745,3.9a.991.991,0,1,1,.991-.991A.991.991,0,0,1,7.984,11.024Zm2.148-3.345H8.885a.554.554,0,0,1,0-1.108h1.247a.554.554,0,0,1,0,1.108Z"
  })));
};

var _default = CategoryCodeMILX;
exports.default = _default;